import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-localize-redux';
import { IconSizes } from '../../../components/foundations/Icon';
import { Button } from '../../../components/widgets';
import StepCard from '../StepCard';
import css from './ReviewPageStep.css';

const ReviewCard = ({
    pageId,
    onEditStep,
    title,
    titleTextReplace,
    info,
    infoTextReplace,
    highlightInfo,
    description,
    descriptionTextReplace,
    children,
}) => (
    <StepCard
        title={title}
        titleTextReplace={titleTextReplace}
        info={info}
        infoTextReplace={infoTextReplace}
        highlightInfo={highlightInfo}
        description={description}
        descriptionTextReplace={descriptionTextReplace}
        headerChildren={
            <Button
                type="secondary"
                Icon="pencil-line"
                iconLocation="left"
                iconSize={IconSizes.X_SMALL}
                onClick={() => onEditStep(pageId)}
            >
                <Translate id="STATIC.BUTTONS.EDIT" />
            </Button>
        }
        className={css.sectionCard}
        collapsible
    >
        {children}
    </StepCard>
);

ReviewCard.propTypes = {
    pageId: PropTypes.string.isRequired,
    onEditStep: PropTypes.func.isRequired,
    title: PropTypes.string,
    titleTextReplace: PropTypes.object,
    info: PropTypes.string,
    infoTextReplace: PropTypes.object,
    highlightInfo: PropTypes.bool,
    description: PropTypes.string,
    descriptionTextReplace: PropTypes.object,
    children: PropTypes.node.isRequired,
};

export default ReviewCard;
